import { render, staticRenderFns } from "./ProductRecipeCompareDialog.vue?vue&type=template&id=61d58f89&scoped=true&"
import script from "./ProductRecipeCompareDialog.vue?vue&type=script&lang=js&"
export * from "./ProductRecipeCompareDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecipeCompareDialog.vue?vue&type=style&index=0&id=61d58f89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d58f89",
  null
  
)

export default component.exports